import { useUser } from 'contexts/UserContext'
import { useEffect } from 'react'

export default function Logout() {
  const { setUser } = useUser()

  useEffect(() => {
    setUser(null)

    if (document.body.classList.contains('dark')) {
      document.body.classList.remove('dark')
    }
  }, [])

  return <></>
}
